import './sidebar-content-end.scss';

export default () => {
	let links = document.querySelectorAll( 'a[href^="#"]' );

	// Loop through the links and add a click event listener
	links.forEach( function ( link ) {
		link.addEventListener( 'click', function ( event ) {
			// Prevent the default anchor behavior
			event.preventDefault();

			// Get the target element id
			let targetId = this.getAttribute( 'href' ).substring( 1 );

			// Get the target element
			let targetElement = document.getElementById( targetId );

			// If the target element exists, scroll to it
			if ( targetElement ) {
				targetElement.scrollIntoView( {
					behavior: 'smooth',
					block: 'start',
				} );
			}
		} );
	} );
};
